import React from "react";
import { connect } from "react-redux";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import ImageContainer from "@components/imageContainer";
import SectionDivider from "@components/common/divider";
import Hyperlink from "@components/common/hyperlink";
import { getWidgetSpecificIsVisible } from "@utils/index";
import {
  Wrapper,
  Header,
  MakeModel,
  RegNumber,
  Content,
  FieldValueWrapper,
  Field,
  Value,
  ContentHeader
} from "./styles";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const UpdateDetailsCard = (props: any) => {
  const {
    reg_no,
    make,
    model,
    actions,
    wrapperStyles,
    variant,
    fuelType,
    makeYear,
    owner,
    email,
    pincode,
    isExternalCng,
    nominee,
    gstNumber,
    is_visible,
    product
  } = props;

  const { } = actions || {};

  console.log(props.actions,"action");
  const handleActionClick = (editKey: string) => {
    const actionKey = `on_click_${editKey}`;
    const fieldActions = actions?.[actionKey] || actions?.on_click;
    if (fieldActions?.length > 0) {
      fieldActions.forEach((eachFunc: any) => {
        if (typeof eachFunc.funCall === "function") {
          eachFunc.funCall(eachFunc.args);
          console.log(eachFunc.args,"eachFunc");
        }
      });
    }
  };
  const mmvImg =
    product === "bike"
      ? "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-prequote/bike_insurance.svg"
      : "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-prequote/car_insurance.svg";

  const renderField = (
    label: string,
    value: any,
    editKey: string,
    hideActions = false
  ) => {
    const isPresent = value !== null;

    return is_visible ? (
      <FieldValueWrapper>
        <Flex justifyContent="space-between">
          <Field>{label}</Field>
          {!hideActions &&
            (isPresent ? (
              <Hyperlink
                type="PRIMARY"
                text="Edit"
                styles={{ fontSize: "14px" }}
                clickHandler={() => handleActionClick(editKey)}
              />
            ) : (
              <div
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <ImageContainer
                  imgSrc="https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-common/add-icon.svg"
                  height={14}
                  width={14}
                  alt="add"
                />
                <Hyperlink
                  type="PRIMARY"
                  text="Add"
                  styles={{ fontSize: "14px" }}
                  clickHandler={() => handleActionClick(editKey)}
                />
              </div>
            ))}
        </Flex>
        <Value>{isPresent ? value : ""}</Value>
      </FieldValueWrapper>
    ) : null;
  };

  return (
    <>
      <Wrapper styles={wrapperStyles}>
        <Header>
          <Flex
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
            styles={{ gap: "12px" }}
          >
            <ImageContainer
              imgSrc={mmvImg}
              alt="vehicle-dummy"
              width={60}
              height={60}
            />
            <Flex flexDirection="column" styles={{ gap: "4px" }}>
              <Flex flexDirection="row" justifyContent="space-between">
                <MakeModel>
                  {make} {model}
                </MakeModel>
              </Flex>
              <RegNumber>{reg_no}</RegNumber>
            </Flex>
          </Flex>
        </Header>
      </Wrapper>
      <ContentHeader>Vehicle details</ContentHeader>
      <Content>
        {renderField("Variant", variant, "variant")}
        <SectionDivider styles={{ borderTop: "1px solid #e0e0e8" }} />
        {renderField("Fuel Type", fuelType, "fuelType", true)}
        <SectionDivider styles={{ borderTop: "1px solid #e0e0e8" }} />
        {renderField("Make year", makeYear, "makeYear", true)}
        {product !== "bike" && (
          <>
            <SectionDivider styles={{ borderTop: "1px solid #e0e0e8" }} />
            {renderField(
              "External CNG kit installed?",
              isExternalCng === true
                ? "Yes"
                : isExternalCng === false
                  ? "No"
                  : null,
              "isExternalCng"
            )}
          </>
        )}
      </Content>

      <ContentHeader>Personal details</ContentHeader>
      <Content>
        {renderField(
          "Owner name",
          owner
            ? owner
                .split(" ")
                .map(
                  (word) =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                )
                .join(" ")
            : "",
          "ownerName"
        )}
        <SectionDivider styles={{ borderTop: "1px solid #e0e0e8" }} />
        {renderField("Email", email, "email")}
        <SectionDivider styles={{ borderTop: "1px solid #e0e0e8" }} />
        {renderField("Pincode", pincode, "pincode")}
        <SectionDivider styles={{ borderTop: "1px solid #e0e0e8" }} />
        {renderField("Nominee", nominee, "nominee")}
        <SectionDivider styles={{ borderTop: "1px solid #e0e0e8" }} />
        {renderField("GST number (Optional)", gstNumber, "gstNumber")}
      </Content>
    </>
  );
};

export default connect(mapStateToProps)(UpdateDetailsCard);
